<template>
  <OPanelLink
    v-if="data"
    :path="`/appointment/${data.idReservation}?date=${data.date}`"
  >
    <AttachmentEmbedContainer
      :title="`${data._servicesLabel || ''} with ${data.employeesLabel || ''}`"
      :info="data.dateLabel"
      type="Appointment"
      icon="reservation"
    />
  </OPanelLink>
</template>

<script setup lang="ts">
import AttachmentEmbedContainer from '../../embed/Container.vue'

import { Reservation } from '~/_api/models/reservation'

interface Props {
  attachment: Record<string, any>
}

const props = defineProps<Props>()

const data = computed(() => props.attachment?.object ? new Reservation(props.attachment.object) : null)
</script>
